import React from 'react'
import {useContext, createContext} from 'react'


const CustomerCartContext = createContext();
export const CustomerCartProvider = ({ children }) => {

  const [cart, setCart] = React.useState([]);

  const addToCart = (item) => {
    setCart(currentCart => [...currentCart, item])
  }

  const contextValue = {
    cart,
    addToCart
  }
  return (
    <CustomerCartContext.Provider value={contextValue}>
      {children}
    </CustomerCartContext.Provider>
  )
}

export const useCart = () => {
  return useContext(CustomerCartContext);
};